import { render, staticRenderFns } from "./xingyuanView.vue?vue&type=template&id=afd5649e&scoped=true"
import script from "./xingyuanView.vue?vue&type=script&lang=js"
export * from "./xingyuanView.vue?vue&type=script&lang=js"
import style0 from "./xingyuanView.vue?vue&type=style&index=0&id=afd5649e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afd5649e",
  null
  
)

export default component.exports